import { render, staticRenderFns } from "./Fortune.vue?vue&type=template&id=6b17c510&scoped=true&"
import script from "./Fortune.vue?vue&type=script&lang=js&"
export * from "./Fortune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17c510",
  null
  
)

export default component.exports